import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export const exportEventAsReport = (event) => {
  const doc = new jsPDF("p", "mm", "a4");

  // Colors from your CSS theme (HEX for simplicity)
  const theme = {
    primary: "#FF6123",       // --color-primary
    background: "#0A0A0A",    // --color-surface-background
    card: "#454343",          // --color-surface-card
    input: "#121212",         // --color-surface-input
    textBase: "#FFFFFF",      // --color-text-base
    textSecondary: "#ADADAD", // --color-text-secondary
    grey: "#A1A1A1",          // --color-grey
  };

  // Title
  doc.setFontSize(18);
  doc.setTextColor(theme.primary);
  doc.text(`Event Report: ${event?.eventName ?? "Untitled"}`, 14, 20);

  // Summary row
  const summary = [
    [
      event?.status ?? "N/A",
      (event?.eventStartDate ?? "").split("T")[0] || "N/A", // YYYY-MM-DD
      event?.location ?? "N/A",
      event?.expectedAttendees ?? event?.attendance ?? 0,
      event?.clickCount ?? event?.taps ?? 0,
    ],
  ];

  autoTable(doc, {
    head: [["Status", "Date", "Location", "Attendees", "Taps"]],
    body: summary,
    startY: 28,
    theme: "grid",
    styles: { fontSize: 11, halign: "center", textColor: theme.textBase },
    headStyles: {
      fillColor: theme.primary,
      textColor: theme.textBase,
      fontStyle: "bold",
    },
    bodyStyles: {
      fillColor: theme.input,
      textColor: theme.textSecondary,
    },
    alternateRowStyles: { fillColor: theme.card },
  });

  // Details table
  const details = [
    [
      "Engagement Rate",
      event?.expectedAttendees
        ? `${((event?.clickCount / event?.expectedAttendees) * 100).toFixed(2)}%`
        : event?.engagementRate ?? "0%",
    ],
    [
      "Post-Event Retention",
      event?.expectedAttendees
        ? `${((event?.postEventClickCount / event?.expectedAttendees) * 100).toFixed(2)}%`
        : "0%",
    ],
    ["Bracelet URL", event?.baseUrl ?? "N/A"],
    ["Destination URL", event?.destinationUrl ?? "N/A"],
  ];

  autoTable(doc, {
    head: [["Field", "Value"]],
    body: details,
    startY: doc.lastAutoTable.finalY + 10,
    theme: "grid",
    styles: { fontSize: 11, valign: "middle", textColor: theme.textBase },
    headStyles: {
      fillColor: theme.primary,
      textColor: theme.textBase,
    },
    bodyStyles: {
      fillColor: theme.input,
      textColor: theme.textSecondary,
    },
    columnStyles: {
      0: { cellWidth: 60 },
      1: { cellWidth: 120 },
    },
  });

  // Footer
  doc.setFontSize(9);
  doc.setTextColor(theme.grey);
  doc.text("Generated by SparkMotion Organizer", 14, 290);

  doc.save(`Event_Report_${event?.title ?? "Card"}.pdf`);
};
